import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/config-global';

import ResetPassword  from 'src/sections/auth/reset-password';

export default function Page() {
  return (
    <>
      <Helmet>
        <title> {`Reset Password - ${CONFIG.appName}`}</title>
      </Helmet>

      <ResetPassword />
    </>
  );
}